import { fetchAgentStatus } from 'api/conversation'
import { receiveAgentStatus } from 'modules/conversations/actions'
import { pathOr } from 'ramda'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AgentStatus } from 'types/conversation'

const useActiveAgentStatus = (agentId: number, isBot: boolean = false) : AgentStatus => {
  const dispatch = useDispatch()
  const agentStatus = useSelector(state => pathOr(null, ['conversations', 'agentPresence', `${agentId}`, 'status'], state))

  useEffect(() => {

    if (isBot) {
      return
    }

    if (!agentStatus && agentId) {
      const fetchAgentStatusById = async () => {
        const { data } = await fetchAgentStatus(agentId)
        dispatch(receiveAgentStatus({
          agentId,
          availability: data.availability,
          lastActivity: data.lastActivityAt
        }))
      }

      fetchAgentStatusById()
    }
  }, [dispatch, agentId, isBot, agentStatus])

  return (
    isBot ?
      AgentStatus.ONLINE : (
        !agentStatus
          ? AgentStatus.OFFLINE
          : agentStatus
      )
  )
}

export default useActiveAgentStatus
